var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "custom-callout",
    {
      staticClass: "mb-3",
      attrs: {
        "border-color-hex": _vm.data.requestStatusColor,
        "has-toggle": false
      }
    },
    [
      _c("div", { staticClass: "row py-2 mr-md-0 n-ml" }, [
        _c("div", { staticClass: "col-12 col-md-2 text-center border-right" }, [
          _c(
            "div",
            {
              class: `badge badge-pill font-16 mt-3 py-2 ${_vm.getStatusWidth} mx-auto color-black`,
              style: { "background-color": _vm.data.requestStatusColor }
            },
            [_vm._v(" " + _vm._s(_vm.data.requestStatusName) + " ")]
          )
        ]),
        _c("div", { staticClass: "col-12 col-md-10" }, [
          _c("div", { staticClass: "row pt-2" }, [
            _c("div", { staticClass: "col-12 col-md-5" }, [
              _c("div", { staticClass: "row pl-2" }, [
                _c("div", { staticClass: "col-12 col-md-7 pr-0" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Número de Propuesta: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("empty")(_vm.data.proposalNumber)) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md-5 pr-0" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Tipo de Proponente: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm.data.proponentTypeName) + " ")
                    ])
                  ])
                ])
              ])
            ]),
            _c("div", { staticClass: "col-12 col-md-7 custom-pl" }, [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-12 col-md-5 pr-0" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Nombre del Proponente: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(" " + _vm._s(_vm.data.providerName) + " ")
                    ])
                  ])
                ]),
                _c("div", { staticClass: "col-12 col-md-4 pr-0 custom-pl" }, [
                  _c("div", [
                    _c(
                      "span",
                      { staticClass: "color-gray-6 d-block font-14" },
                      [_vm._v(" Fecha de Sometido: ")]
                    ),
                    _c("span", { staticClass: "font-16 color-black" }, [
                      _vm._v(
                        " " +
                          _vm._s(_vm._f("date")(this.data.submittedDate)) +
                          " "
                      )
                    ])
                  ])
                ]),
                _c(
                  "div",
                  {
                    staticClass:
                      "col-12 col-md-3 d-inline d-md-flex align-items-center justify-content-center"
                  },
                  [
                    _c(
                      "action-button",
                      {
                        attrs: {
                          id: "on-detail-btn-identifier",
                          i: "fas fa-file-import",
                          variant: "outline-success m-2 px-4"
                        },
                        on: { click: _vm.onDetailHanlder }
                      },
                      [_vm._v(" Entrar ")]
                    )
                  ],
                  1
                )
              ])
            ])
          ])
        ])
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }